import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
import users from './users'
import whatsappInstances from './whatsapp-instances'
import instanceIncidents from './instance-incidents'
import contacts from './contacts'
import contactGroups from './contact-groups'
import messageTemplates from './message-templates'
import messageCampaigns from './message-campaigns'
import messages from './messages'
import incomingMessages from './incoming-messages'
import apiApplications from './api-applications'
import paymentEvents from './payment-events'
import webhookDeliveries from './webhook-deliveries'
/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
export const dashboard = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

dashboard.definition = {
    methods: ["get","head"],
    url: '/admin-panel',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
dashboard.url = (options?: RouteQueryOptions) => {
    return dashboard.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
dashboard.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
dashboard.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: dashboard.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
const dashboardForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
dashboardForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\AdminPanel\DashboardController::__invoke
* @see app/Http/Controllers/AdminPanel/DashboardController.php:33
* @route '/admin-panel'
*/
dashboardForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: dashboard.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

dashboard.form = dashboardForm

const adminPanel = {
    dashboard: Object.assign(dashboard, dashboard),
    users: Object.assign(users, users),
    whatsappInstances: Object.assign(whatsappInstances, whatsappInstances),
    instanceIncidents: Object.assign(instanceIncidents, instanceIncidents),
    contacts: Object.assign(contacts, contacts),
    contactGroups: Object.assign(contactGroups, contactGroups),
    messageTemplates: Object.assign(messageTemplates, messageTemplates),
    messageCampaigns: Object.assign(messageCampaigns, messageCampaigns),
    messages: Object.assign(messages, messages),
    incomingMessages: Object.assign(incomingMessages, incomingMessages),
    apiApplications: Object.assign(apiApplications, apiApplications),
    paymentEvents: Object.assign(paymentEvents, paymentEvents),
    webhookDeliveries: Object.assign(webhookDeliveries, webhookDeliveries),
}

export default adminPanel